import { OFPageType } from '../../../../generated/api/oFPageType.js';
import { type OpenFormAnswers } from '../../OpenFormAnswers.js';
import { OpenFormPageAvailability } from './OpenFormPageAvailability.js';
import { OpenFormPageInformative } from './OpenFormPageInformative.js';
import { OpenFormPageQuestion } from './OpenFormPageQuestion.js';
import type { OpenFormSection } from '../../../../generated/api/openFormSection.js';

export const OpenFormPageType = ({
  section,
  answers,
  disabled,
}: {
  section: OpenFormSection;
  answers: OpenFormAnswers;
  disabled: boolean;
}) => {
  switch (section.pageType) {
    case OFPageType.AVAILABILITY_CHECK:
      return <OpenFormPageAvailability section={section} answers={answers} disabled={disabled} />;
    case OFPageType.INFORMATIVE:
      return <OpenFormPageInformative section={section} />;
    case OFPageType.ORDER_ENRICHMENT:
    case OFPageType.QUESTION_ADDITIONAL_SERVICES:
    case OFPageType.QUESTION_MAIN_PRODUCTS:
    case OFPageType.QUESTION_SUBSCRIPTION_TYPE:
    case OFPageType.UNAVAILABLE_PRODUCT_DETAILS:
      return <OpenFormPageQuestion section={section} answers={answers} disabled={disabled} />;
    default:
      return null;
  }
};
